import { IStoreReady } from "@/store/lib/storeSupport";
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import {
    ILoyaltyCertType,
    ILoyaltyCertTypeListItem,
} from "@/entity/loyalty/loyaltyCert/loyaltyCertType/LoyaltyCertType.types";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { LoyaltyCertTypeGeneralRequestType } from "@/form/loyalty/loyaltyCertType/LoyaltyCertTypeGeneral.types";
//import { LoyaltyCertTypeAddFormRequestType } from '@/form/loyalty/loyaltyCertType/LoyaltyCertTypeAddForm.types';
import { LoyaltyCertTypeAddRequestType } from "@/form/loyalty/loyaltyCertType/LoyaltyCertType.types";
import { ResponseDataType } from "@/form/form.types";
import { prepareFormData } from "@/store/utils/formDataHelper";
@Module({
    namespaced: true,
    name: "loyaltyCertType",
    store,
    dynamic: true,
})
class LoyaltyCertTypeModule extends VuexModule implements IStoreReady {
    loyaltyCertTypes: ILoyaltyCertType | null = null;
    loyaltyCertType: ILoyaltyCertTypeListItem | null = null;
    loyaltyCertTypeLoaded = false;
    loyaltyCertTypesLoaded = false;
    ready = false;
    @MutationAction
    async fetchAll(
        data?: PaginationRequestType,
    ): Promise<{ loyaltyCertTypes: ILoyaltyCertType; loyaltyCertTypeLoaded: boolean }> {
        let loyaltyCertTypeLoaded = false;
        const loyaltyCertTypes = await store.$repository.loyaltyCertType.fetchAll(prepareFormData(data));

        if (loyaltyCertTypes) {
            loyaltyCertTypeLoaded = true;
        }
        return { loyaltyCertTypes, loyaltyCertTypeLoaded };
    }
    @MutationAction
    async fetchData(
        data: PaginationRequestType,
    ): Promise<{ loyaltyCertType: ILoyaltyCertTypeListItem; loyaltyCertTypeLoaded: boolean }> {
        let loyaltyCertTypeLoaded = false;
        const loyaltyCertType = await store.$repository.loyaltyCertType.fetchData(data);
        if (loyaltyCertType) {
            loyaltyCertTypeLoaded = true;
        }
        return { loyaltyCertType, loyaltyCertTypeLoaded };
    }

    @Action({ rawError: true })
    async create(data: LoyaltyCertTypeAddRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.loyaltyCertType.create(data);
        return resp;
    }
    @Action({ rawError: true })
    async update(data: LoyaltyCertTypeGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.loyaltyCertType.update(data);
    }
    @Mutation
    setReady(st: boolean) {
        this.ready = st;
    }
    /*@MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ salon: ILoyaltyCertTypeListItem  ; counterpartiesLoaded: boolean }> {
        let counterpartiesLoaded = false;
        const salon = await store.$repository.counterparties.fetchData(data);
        if (salon) {
            counterpartiesLoaded = true;
        }
        return { salon, counterpartiesLoaded};
    }
    @Action({rawError: true})
    async create(data: LoyaltyCertTypeGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.create(data);
        return resp;
    }
    @Action({rawError: true})
    async update(data: LoyaltyCertTypeGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.update(data);
        return resp;
    }*/
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.loyaltyCertType.delete(data);
        return resp;
    }
}

export const LoyaltyCertTypeStore = getModule(LoyaltyCertTypeModule);
